import { startAppGenerationFromPrompt } from '@/features/chat/services/start-app-generation-from-prompt'
import type { ImportedCogoXyzApp } from './cogo-xyz-import'

export interface GeneratedPromptCogoXyzApp extends ImportedCogoXyzApp {
  metadata: {
    mode: 'studio-request-app-generation'
    appSpecId: string
    appSpecName: string
    generationAwaited: true
  }
}

export async function generatePromptAppInput(params: {
  title: string
  input: string
}): Promise<GeneratedPromptCogoXyzApp> {
  const started = await startAppGenerationFromPrompt(params.input, {
    generationEntry: 'source-import',
    registerLibraryItem: false,
  })
  if (started.status === 'clarification-required') {
    throw new Error(
      started.sourceSufficiency.questions[0]?.question ??
        'Source assessment must be completed before app generation.',
    )
  }
  // Task 4 — this is a non-UI service path (no chat thread to write a
  // notice into), so — mirroring the branch immediately above — surface the
  // first blocking item's own explanation as a thrown error rather than
  // silently proceeding.
  if (started.status === 'generation-readiness-blocked') {
    const [firstBlocking] = started.readiness.items.filter(
      (item) => item.kind === 'blocking',
    )
    throw new Error(
      firstBlocking?.explanation ??
        'This project is not ready to generate yet.',
    )
  }
  await started.generation

  return {
    projectId: started.projectId,
    name: started.appSpec.name || params.title,
    previewUrl: `${window.location.origin}/ide/${started.projectId}`,
    bundleRef: `cogo-xyz://generated-studio-apps/${started.projectId}`,
    metadata: {
      mode: 'studio-request-app-generation',
      appSpecId: started.appSpec.appId ?? started.projectId,
      appSpecName: started.appSpec.name,
      generationAwaited: true,
    },
  }
}
